import {defineStore} from 'pinia';
import {DI, getDIContainer} from '@/brief-hub/config/DependencyInjection';
import UserResource from '@/brief-hub/user/UserResource';
import {ref, Ref} from 'vue';

export const useConnectedUserStore = defineStore('connected-user', () => {
    // State
    const user: Ref<UserResource | null> = ref(null);
    const searchedIdentities: Ref<string[]> = ref([]);

    // Actions
    async function getConnectedUser() {
        const data = await getDIContainer()[DI.userService].get();
        updateConnectedUser(data[0]);
    }
    function updateConnectedUser(payload: UserResource | null): void {
        user.value = payload || null;
        searchedIdentities.value = payload ? [payload.identityId] : [];
    }
    function updateSearchedIdentities(payload: string[]): void {
        searchedIdentities.value = payload;
    }

    return {user, searchedIdentities, getConnectedUser, updateConnectedUser, updateSearchedIdentities};
});
